




import Meter from "@/components/Meter.vue";
import {Contest} from "@/model/Contest";

export default {
  name: "ToWin",
  components: {
    Meter
  },
  data: () => {
    return {
      result: ''
    }
  },
  mounted() {
    (this as any).getToWin()
      .then((result: string) => ((this as any).result = result))
  },
  methods: {
    getToWin(): Promise<string> {
      return (this as any).$api.get('/contests')
        .then(({ data }: { data: { 'hydra:member': Contest[] } }) => this.getSumRewards(data['hydra:member'] || []))
        .then((sum: number): string => `${sum}$`);
    },
    getSumRewards(contests: Contest[]): number {
      let sum = 0;
      for (const contest of contests) {
        const endAt = new Date(contest.endAt);
        const now = new Date();
        const isFinished = endAt < now;

        if (isFinished) {
          continue;
        }

        sum += typeof contest.rewardsValue === 'number' ? contest.rewardsValue : parseInt(contest.rewardsValue)
      }
      return sum;
    }
  }
}
